import React from 'react';
import Scroll from 'react-scroll';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Select from 'react-select';

import LoginAPI from '../../api/LoginAPI'
import RegEx from '../../util/RegEx';
import withRouter from '../../util/WithRouter';
import Util from '../../util/Util';
import CountryCodes from '../../util/CountryCode';
import Currencies from '../../util/Currency';
import CountryUtc from '../../util/CountryUtc';
import ApiUiController from '../../controller/ApiUiController';
import config from '../../config/config';

class Registration extends React.Component {

  constructor(props) {
    super(props);
    const currency = Currencies.find(currency => currency.label === 'INR');
    const code = CountryCodes.find(code => code.value === '+91');
    const zone = CountryUtc.find(code => code.time === '+05:30');
    this.state = { reg: { name: '', admin_name: '', admin_no: '', admin_email: '', zone,
      check: false, code: code, currency: currency }, inValid: { }, inApiCall: false };
  }

  handleChange = (key, value) => {
    const reg = { ...this.state.reg};
    if(key === 'admin_email') reg[key] = value.toLowerCase();
    else reg[key] = value;
    this.setState({ ...this.state, reg: reg });
  }
  
  validate = () => {
    const reg = this.state.reg;
    let validate = {};
    if(!RegEx.isMatch(reg.name, true, '^[a-zA-Z0-9 .]{3,255}$')) validate['name'] = 'Invalid Company Name';
    if(!RegEx.isMatch(reg.admin_name, true, '^[a-zA-Z ]{3,255}$')) validate['admin_name'] = 'Wrong Admin Name';
    if(!RegEx.isMatch(reg.admin_no, true, RegEx.Phone)) validate['admin_no'] = 'Wrong Admin Contact No' ;
    if(!RegEx.isMatch(reg.admin_email, true, RegEx.Email)) validate['admin_email'] = 'Wrong Admin Email';
    if(!reg.check) validate['check'] = 'Accept terms and conditions.';
    return validate;
  }

  onSubmit = () => {
    const validate = this.validate();
    const keys =  Object.keys(validate);
    if(keys.length !== 0) {
      this.setState({ ...this.state, inValid: { ...validate }});
      Scroll.scroller.scrollTo(keys[0], { duration: 1500, smooth: true });
    } else {
      this.isError = false;
      this.setState({ ...this.state, inApiCall: true });
      LoginAPI.registration(this.state.reg, this.success, this.failure);
    }
  }
  failure = response => {
    this.setState({ ...this.state, inApiCall: false});
    Util.showError(response);
  }

  success = () => {
    Util.showNotification('Successful', 'Registration successfully.', 'success');
    window.location.href = config.auth;
  }
  
  render() {
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <h4 className="regformheading1">Company Information</h4>
        <Form.Group as={Col}>
          <Scroll.Element name="name" />
          <label>Company Name</label> { RegEx.showError(this.state.inValid, 'name') }
          <FormControl className={RegEx.class(this.state.inValid, 'name')}
            type="text" value={this.state.reg.name}
            onChange={event => this.handleChange('name', event.target.value)} />
        </Form.Group>

        <h4 className="regformheading2">Admin Person Information</h4>
        <Form.Group as={Col}>
          <Scroll.Element name="admin_name" />
          <label>Admin Name</label> { RegEx.showError(this.state.inValid, 'admin_name') }
          <FormControl className={RegEx.class(this.state.inValid, 'admin_name')}
            type="text" value={this.state.reg.admin_name}
            onChange={event => this.handleChange('admin_name', event.target.value)} />
        </Form.Group>

        <Form.Group as={Col}>
          <Scroll.Element name="code" />
          <label>Country Code</label>
          <Select value={this.state.reg.code} options={CountryCodes} isSearchable={true}
            onChange={seletced => this.handleChange('code', seletced)} />
        </Form.Group>

        <Form.Group as={Col}>
          <Scroll.Element name="admin_no" />
          <label>Admin Contact No.</label>{RegEx.showError(this.state.inValid, 'admin_no')}
          <FormControl className={RegEx.class(this.state.inValid, 'admin_no')}
            type="text" value={this.state.reg.admin_no}
            onChange={event => this.handleChange('admin_no', event.target.value)} />
        </Form.Group>
        
        <Form.Group as={Col}>
          <Scroll.Element name="admin_email" />
          <label>Admin Email / Login</label>{RegEx.showError(this.state.inValid, 'admin_email')}
          <FormControl className={RegEx.class(this.state.inValid, 'admin_email')}
            type="text" value={this.state.reg.admin_email}
            onChange={event => this.handleChange('admin_email', event.target.value)} />
        </Form.Group>

        <Form.Group as={Col}>
          <Scroll.Element name="currency" />
          <label>Default Currency</label>
          <Select value={this.state.reg.currency} options={Currencies} isSearchable={true}
            onChange={seletced => this.handleChange('currency', seletced)} />
        </Form.Group>

        <Form.Group as={Col}>
          <label>Default Time Zone</label>
          <Select value={this.state.reg.zone} options={CountryUtc} isSearchable={true}
            onChange={seletced => this.handleChange('zone', seletced)} />
        </Form.Group>
        
        <Form.Group as={Col}>
          <Scroll.Element name="check" />
          {RegEx.showError(this.state.inValid, 'check')}
          <Form.Check checked={this.state.reg.check}
            onChange={event => this.handleChange('check', event.target.value)} />
          <label className={`form-check-label ${RegEx.class(this.state.inValid, 'check')}`}>
            By clicking on SIGN UP you agree to our terms and you acknowledge
            having read our privacy notice.
          </label>
        </Form.Group>
        
        <Form.Group as={Col}>
          <Button onClick={this.onSubmit}
            className="btnsub btn btn-primary btn-lg btn-block"> Sign Up </Button>
        </Form.Group>   
      </ApiUiController>
    );
  }
}
export default withRouter(Registration);
